<template>
  <Menubar :model="items" />
</template>

<script>
import Menubar from "primevue/menubar";

export default {
  components: {
    Menubar
  },
  data() {
    return {
      items: [
        {
          label: "Approve Users",
          to: "/approve-user",
          icon: "pi pi-fw pi-user-plus",
          visible: () => this.isUserAdmin()
        },
        {
          label: "Backorders",
          to: "/backorderCustList",
          icon: "pi pi-fw pi-file-excel",
          visible: () => this.isOPsCXTeamUser() || this.isUserAdmin()
        },        
        {
          label: "Planning Allocation",
          to: "/planning-allocation",
          icon: "pi pi-fw pi-file-excel",
          visible: () => this.isOPsCXTeamUser() || this.isUserAdmin()
        },
        {
          label: "Bundle",
          to: "/bundle",
          icon: "pi pi-fw pi-file-excel",
          visible: () => this.isOPsCXTeamUser() || this.isUserAdmin()
        },
        {
          label: "Master Liability Chart",
          to: "/master-liability-chart",
          icon: "pi pi-fw pi-file",
          visible: () => this.isMasterLiabilityChartUser() || this.isUserAdmin()
        },
        { label: "Sign Out", icon: "pi pi-fw pi-power-off", to: "/login" }
      ],
      userInfo: {}
    };
  },
  methods: {
    isUserAdmin() {
      if (this.userInfo.role == "Admin" && this.userInfo.team == "Production Team") {
        return true;
      } else {
        return false;
      }
    },
    isOPsCXTeamUser() {
      if (this.userInfo.role == "Staff" && (this.userInfo.team == "OPs Team" || this.userInfo.team == "CX Team")) {
        return true;
      } else {
        return false;
      }
    },
    isMasterLiabilityChartUser() {
      if (this.userInfo.role == "Staff" && (this.userInfo.team == "Finance Team" || this.userInfo.team == "Factory Team" || this.userInfo.team == "Production Team")) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    if (sessionStorage.getItem("User Information")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("User Information"));
    }
  }
};
</script>
